// extracted by mini-css-extract-plugin
export default {"container":"card-list-container-l8GMZL"};